export default class SocialShareLinks {
  constructor(event, publisherSettings) {
    this.event = event;
    this.socialShareSettings = publisherSettings.publisher.social_share_data;
  }

  get facebookURL() {
    return (
      'https://www.facebook.com/sharer/sharer.php?u=' +
      this.event.absoluteHref +
      '&quote=' +
      this.socialShareMessage +
      ' ' +
      this.generateHashtags(' #')
    );
  }

  get twitterURL() {
    return (
      'https://twitter.com/intent/tweet?url=' +
      this.event.absoluteHref +
      '&text=' +
      this.socialShareMessage
    );
    twitterShareUrl += '&hashtags=' + this.generateHashtags(',');
  }

  get linkedInURL() {
    return (
      'https://www.linkedin.com/shareArticle?mini=true&url=' +
      this.event.absoluteHref +
      '&title=' +
      encodeURIComponent(event.title) +
      '&summary=' +
      this.socialShareMessage +
      ' ' +
      this.generateHashtags(' #')
    );
  }

  generateHashtags(separator) {
    const hashtags_array = [
      this.event.categoryNames[0],
      this.event.town,
      this.event.hashtag,
      'SocialEvvnt',
    ];
    const hashtags = hashtags_array.filter(Boolean).map(function (tag) {
      return tag.replace(/\W/g, '');
    });
    return encodeURIComponent(hashtags.join(separator));
  }

  get socialShareMessage() {
    const event = this.event;
    let description =
      this.socialShareSettings.message_template ||
      '%event_title% %artists% in %city% at %venue_name%, %start_time%, %prices% %publisher_twitter%';

    const twitterName = this.socialShareSettings.twitter_name
      ? 'Follow us on @' + this.socialShareSettings.twitter_name
      : '';
    const socialInfoTags = {
      '%event_title%': event.title,
      '%city%': event.town,
      '%venue_name%': event.venueName,
      '%country%': '#' + event.country,
      '%start_time%': event.fullDateTimeDesc,
      '%event_link%': event.mainLink,
      '%artists%': event.artists?.length ? 'with #' + event.artists.join(' #') : '',
      '%category%': '#' + event.categoryNames[0],
      '%hashtags%': '#' + event.hashtag,
      '%publisher_twitter%': twitterName,
    };

    if (!event.town) {
      description = description.replace(' in %city%', '');
    }

    if (!event.venueName) {
      description = description.replace(' at %venue_name%', '');
    }

    for (let key in socialInfoTags) {
      description = description.replace(key, socialInfoTags[key]);
    }
    description = description.replace(/\s+/g, ' ');
    description = description.replace(', ,', ',');
    description = description.replace('#,', ' ');
    description = description.replace(' ,', ',');
    return encodeURIComponent(description);
  }
}
